var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { useDir } from '@progress/kendo-react-common';
/**
 * @hidden
 */

export var SLIDER_LABEL_ATTRIBUTE = 'data-slider-label';
/**
 * Represents the KendoReact SliderLabel component.
 */

export var SliderLabel = function SliderLabel(props) {
  var _a, _b, _c;

  var sliderLabelRef = React.useRef(null);
  var dir = useDir(sliderLabelRef);
  var style = props.vertical ? {
    bottom: props.position + "%",
    height: '1px',
    width: '100%'
  } : (_a = {}, _a[dir === 'rtl' ? 'right' : 'left'] = props.position + "%", _a.width = '1px', _a);
  var labelTextStyle = props.vertical ? {
    top: '-8px'
  } : (_b = {
    width: '40px'
  }, _b[dir === 'rtl' ? 'right' : 'left'] = "-20px", _b);
  return React.createElement("li", {
    ref: sliderLabelRef,
    role: "presentation",
    className: "k-tick k-tick-large",
    title: props.title,
    style: __assign({
      zIndex: 1,
      position: 'absolute'
    }, style)
  }, React.createElement("span", __assign({
    style: __assign({
      position: 'absolute'
    }, labelTextStyle)
  }, (_c = {}, _c[SLIDER_LABEL_ATTRIBUTE] = true, _c), {
    className: "k-label",
    onClick: props.onClick
  }), props.children));
};